import type { NotificationDelivery } from "./delivery";

const HEADER = ["event", "channel", "recipient", "time", "status", "detail"];

function esc(v: string): string {
  if (/[",\n\r]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

export function deliveriesToCsv(rows: NotificationDelivery[]): string {
  const lines = [HEADER.join(",")];
  for (const d of rows) {
    lines.push(
      [d.event_title, d.channel, d.recipient, d.created_at, d.status, d.detail]
        .map((x) => esc(String(x ?? "")))
        .join(","),
    );
  }
  return lines.join("\n");
}

/** Triggers a browser download of the CSV text. */
export function downloadDeliveriesCsv(
  rows: NotificationDelivery[],
  filename = "delivery-log.csv",
): void {
  const blob = new Blob([deliveriesToCsv(rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
